<script setup lang="ts">
/**
 * **输入行**：左端口 + 控件；已连线则控件隐藏。
 *
 * ⚠️ 端口插槽必须转发 —— 宿主靠它注入真实可拖拽的端口。
 * 这个文件曾经被我和「输出行」搞混过（那次把改名 UI 加错了地方），
 * 现在两者是两个文件，`verify:branches` 会盯着。
 */
import NpSocket from '../NpSocket.vue'
import NpRowWidget from './NpRowWidget.vue'
import type { InputRow, SocketDef } from '../../types/node'
import type { SocketVisualState } from '../../node/socketState'

const props = defineProps<{
  row: InputRow
  inGroup: boolean
  state: SocketVisualState
  def: SocketDef
}>()

const emit = defineEmits<{
  (e: 'widget-update', widgetId: string, value: unknown): void
  (e: 'widget-resize', widgetId: string, height: number): void
}>()
</script>

<template>
  <div
    class="np-row"
    data-row-kind="input"
    :class="{
      'np-row--in-group': props.inGroup,
      'np-row--has-widget': !!props.row.widget && !props.row.socket.connected,
      'is-linked': !!props.row.socket.connected,
    }"
  >
    <slot name="socket-input" :def="props.def" :state="props.state" :row="props.row">
      <NpSocket side="input" :def="props.row.socket" v-bind="props.state" />
    </slot>

    <span v-if="props.row.label" class="np-row__label">
      {{ props.row.label }}
    </span>

    <NpRowWidget
      v-if="props.row.widget && !props.row.socket.connected"
      :row="props.row"
      @update="(id, value) => emit('widget-update', id, value)"
      @resize="(id, height) => emit('widget-resize', id, height)"
    >
      <template #widget-custom="slotProps">
        <slot name="widget-custom" v-bind="slotProps" />
      </template>
    </NpRowWidget>
  </div>
</template>
